import _ from 'lodash';
import * as Sentry from '@sentry/react';
import {
  SCREENER_SESSION_CURRENT_QUESTION,
  SCREENER_SESSION_FETCH_CURRENT_COMPLETED,
  SCREENER_SESSION_NEXT_QUESTION,
  SCREENER_SESSION_QUESTIONS_ORDER,
  SCREENER_SESSION_RESET_SURVEY,
  SCREENER_SESSION_SAVE_SURVEY_FORM,
  SCREENER_SESSION_SAVE_SURVEY_TYPE,
  SCREENER_SESSION_SET_ANSWERS,
  SCREENER_SESSION_SET_SURVEY,
} from '../actions/action-types';

const initialState = {
  formValue: {
    isSurveyUploaded: false,
    sessionId: null,
    accessToken: null,
  },
  answers: null,
  currentQuestion: {},
  isLastQuestion: false,
  nextQuestion: {},
};

const screenerSessionAnswers = (state = initialState, action) => {
  const newForm = {};

  Sentry.setTag('redux.action', action.type);

  switch (action.type) {
    case SCREENER_SESSION_FETCH_CURRENT_COMPLETED: {
      const { questions, sessionId, accessToken } = action.payload;
      newForm.questions = questions;
      newForm.sessionId = sessionId;
      newForm.accessToken = accessToken;

      return {
        ...state,
        formValue: newForm,
      };
    }
    case SCREENER_SESSION_SAVE_SURVEY_FORM:
      return {
        ...state,
        formValue: {
          ...state.formValue,
          ...action.payload,
        },
      };
    case SCREENER_SESSION_SAVE_SURVEY_TYPE:
      return {
        ...state,
        formValue: {
          ...state.formValue,
          ...action.payload,
        },
      };
    case SCREENER_SESSION_SET_SURVEY: {
      const { answers } = action.payload.screener_session;
      newForm.answers = answers;

      return {
        ...state,
        answers,
      };
    }
    case SCREENER_SESSION_RESET_SURVEY:
      return {
        ...initialState,
      };
    case SCREENER_SESSION_QUESTIONS_ORDER: {
      const content = {
        questionsOrder: action.payload.questions,
      };

      if (_.isEmpty(state.currentQuestion && !_.isEmpty(content.questionsOrder))) {
        content.currentQuestion = _.head(content.questionsOrder);
        if (content.questionsOrder[1]) {
          const nextQuestion = content.questionsOrder[1];
          content.nextQuestion = nextQuestion;
        } else {
          content.nextQuestion = content.currentQuestion;
        }
      }

      return {
        ...state,
        ...content,
      };
    }
    case SCREENER_SESSION_CURRENT_QUESTION: {
      const questions = _.get(state, 'questionsOrder', []);

      if (_.isEmpty(questions)) return initialState;

      const { questionId } = action.payload;

      let questionPos = 0;

      if (!_.isEmpty(questionId)) {
        questionPos = _.findIndex(questions, (question) => question.id === questionId);
      }

      if (questionPos === -1) {
        questionPos = 0;
      }

      let isLastQuestion = false;

      const currentQuestion = questions[questionPos];
      let nextQuestion = currentQuestion;

      if (questionPos + 1 < questions.length) {
        nextQuestion = questions[questionPos + 1];
      }

      if (questionPos === questions.length - 1) {
        isLastQuestion = true;
      }

      return {
        ...state,
        currentQuestion,
        nextQuestion,
        isLastQuestion,
        questionIndex: questionPos + 1,
      };
    }
    // Get the next question.
    case SCREENER_SESSION_NEXT_QUESTION: {
      let isLastQuestion = false;
      let nextQuestion = null;

      const {
        currentQuestion = {},
      } = action.payload;

      let newCurrentQuestion = currentQuestion;

      const questions = _.get(state, 'questionsOrder', []);

      const questionPos = _.findIndex(questions, (question) => question.id === currentQuestion.id);

      if (questionPos + 1 < questions.length) {
        newCurrentQuestion = questions[questionPos + 1];
      }

      if (questionPos + 2 < questions.length) {
        nextQuestion = questions[questionPos + 2];
        isLastQuestion = false;
      } else {
        nextQuestion = newCurrentQuestion;
        isLastQuestion = true;
      }

      return {
        ...state,
        currentQuestion: newCurrentQuestion,
        nextQuestion,
        isLastQuestion,
        questionIndex: questionPos + 1,
      };
    }
    case SCREENER_SESSION_SET_ANSWERS: {
      let answers = {};

      if (state.answers) {
        answers = { ...state.answers, ...action.payload.answers };
      } else {
        answers = action.payload.answers;
      }

      return {
        ...state,
        answers,
      };
    }
    default:
      return state;
  }
};

export default screenerSessionAnswers;
